import { JWT_REFRESH_TOKEN, JWT_TOKEN } from '../../constants/localStorage';
import { retrieveFromSessionStorage } from './sessionStorageHelper';

export function getTokens() {
  const JwtToken = retrieveFromSessionStorage(JWT_TOKEN);
  const JwtRefreshToken = retrieveFromSessionStorage(JWT_REFRESH_TOKEN);

  return {
    JwtToken,
    JwtRefreshToken,
  };
}
